import React from 'react'

import { HouseCorporateEveningIndividualCapacityFields } from './capacity-fields/HouseCorporateEveningIndividualCapacityFields'
import { HouseCorporateEveningIndividualHoursFields } from './hours-fields/HouseCorporateEveningIndividualHoursFields'
import { HouseCorporateEveningIndividualVatField } from './vat-field/HouseCorporateEveningIndividualVatField'
import { HouseCorporateEveningIndividualFieldProps } from '../form-container/HouseCorporateEveningIndividualFormContainer'
import { Divider } from '../../../../../../../atoms/divider/Divider'

export const HouseCorporateEveningIndividualOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseCorporateEveningIndividualFieldProps) => {
  return (
    <>
      <Divider />

      <HouseCorporateEveningIndividualCapacityFields {...fieldProps} />

      <Divider />

      <HouseCorporateEveningIndividualHoursFields {...fieldProps} />

      <Divider />

      <HouseCorporateEveningIndividualVatField
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
